import AuthorSelector from './containers/AuthorSelector.jsx';

export default AuthorSelector;
